module.exports = __webpack_public_path__ + "static/media/dylan.547c872d.jpeg";